import { LoaderModule } from './../../shared/loader/loader.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { PetrolSalesService } from './petrol-sales.service';
import { PetrolSalesComponent } from './petrol-sales.component';
import { IPlaceService } from '../../iPlace/iPlace.service';
import { I18NService } from '../../shared/i18n/i18n.service';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  imports: [
    FlexLayoutModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    AngularMultiSelectModule,
    HighchartsChartModule,
    LoaderModule
  ],
  exports: [
    PetrolSalesComponent
  ],
  declarations: [PetrolSalesComponent],
  providers: [PetrolSalesService, I18NService, IPlaceService]
})
export class PetrolSalesModule {

}
